module.exports = __webpack_public_path__ + "media/images/motto-bg2-8f7adf0afeccef526122925301573548.png";